(function(n,t,i,r){var u,f;n[i]=n[i]||{},n[i].initial={accountCode:"BOODL11118",host:"BOODL11118.pcapredict.com"},n[i].on=n[i].on||function(){(n[i].onq=n[i].onq||[]).push(arguments)},u=t.createElement("script"),u.async=!0,u.src=r,f=t.getElementsByTagName("script")[0],f.parentNode.insertBefore(u,f)})(window,document,"pca","//BOODL11118.pcapredict.com/js/sensor.js");

pca.on("ready", function () { pca.sourceString = "Shopify-GuideSetup";});
pca.on("data", function(type, key, data) {
    var countryField = '';
    var proviceField = '';
    for (var i = 0; i < pca.platform.productList[key]['PLATFORM_CAPTUREPLUS'].bindings[0].fields.length; i++) {
        if (pca.platform.productList[key]['PLATFORM_CAPTUREPLUS'].bindings[0].fields[i].element.includes('country')) {
            countryField = pca.platform.productList[key]['PLATFORM_CAPTUREPLUS'].bindings[0].fields[i].element;
        }
        if(pca.platform.productList[key]['PLATFORM_CAPTUREPLUS'].bindings[0].fields[i].element.includes('province')) {
            proviceField = pca.platform.productList[key]['PLATFORM_CAPTUREPLUS'].bindings[0].fields[i].element;
        }
    }
    var c = document.getElementById(countryField);
    if (c) {
        pca.fire(c, 'change');
    }
    var r = document.getElementById(proviceField);
    if (r) {
        for (var i = 0; i < r.options.length; i++) {
            if (r.options[i].text === data.ProvinceName.replace('é', 'e')) {
                r.value = r.options[i].value;
                break;
            }
        }
        pca.fire(r, 'change');
    }
});